import React from "react";

function SvgIcMapPoi126(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M22.95 5L25 7.05v2.9L22.95 12H22v3.858l.427.236.006.014A.993.993 0 0122 18v8.986h-1v-9.412l-6-3.278V26a1 1 0 01-1 1h-2a1 1 0 01-1-1v-5.991L10 20c-.545 0-1-.379-1-1v-5c0-1.306.917-2 2-2h3.007l.03.003c.953 0 1.635.351 2.303.726L21 15.305V12h-.95L18 9.95v-2.9L20.05 5h2.9zM13 7a2 2 0 110 4 2 2 0 010-4z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi126;
